
import { useState } from 'react';

export default function ResidentialFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How long does a typical residential renovation take in Johannesburg?',
      answer:
        'Project timelines vary based on scope. A single-room renovation typically takes 4-6 weeks, while a full home transformation can take 12-20 weeks. During your free site inspection, we provide a detailed timeline with milestones so you always know what to expect.',
    },
    {
      question: 'Do you handle all permits and compliance for structural alterations?',
      answer:
        'Yes. Tadashi Consulting manages all municipal approvals, building plans, and compliance certificates. Our licensed contractors ensure every structural alteration meets South African National Building Regulations (SANS 10400) standards.',
    },
    {
      question: 'What areas in Johannesburg do you service for residential renovations?',
      answer:
        'We service all of greater Johannesburg including Sandton, Bryanston, Fourways, Randburg, Rosebank, Houghton, Hyde Park, Bedfordview, Midrand, and surrounding areas in Gauteng.',
    },
    {
      question: 'How does your pricing work for home renovations?',
      answer:
        'We provide transparent, itemised quotations after a complimentary site inspection. There are no hidden costs. Our quotes include materials, labour, project management, and all finishes. We also offer flexible payment milestones tied to project stages.',
    },
    {
      question: 'Can I live in my home during the renovation?',
      answer:
        'In many cases, yes. We plan our construction phases to minimise disruption. For extensive renovations involving plumbing or structural work, we may recommend temporary relocation for specific phases and will advise you during the planning stage.',
    },
    {
      question: 'Do you provide a warranty on your renovation work?',
      answer:
        'Absolutely. All Tadashi Consulting residential renovations come with a comprehensive workmanship warranty. Structural work carries a 10-year warranty, while finishes and installations are covered for 2-5 years depending on the scope.',
    },
  ];

  return (
    <section className="py-16 md:py-24 lg:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <p className="text-xs font-semibold tracking-widest text-[#D4AF37] uppercase mb-4">
            Common Questions
          </p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#2A2A2A] leading-tight">
            Residential Renovation{' '}
            <span className="font-serif text-[#D4AF37]">FAQ</span>
          </h2>
        </div>

        {/* FAQ container with schema.org markup */}
        <div
          className="space-y-3 md:space-y-4"
          itemScope={true}
          itemType="https://schema.org/FAQPage"
        >
          {faqs.map((faq, index) => (
            <article
              key={index}
              itemScope={true}
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              className="border border-gray-200 rounded-xl md:rounded-2xl overflow-hidden"
            >
              <button
                onClick={() =>
                  setOpenIndex(openIndex === index ? null : index)
                }
                className="w-full flex items-center justify-between p-4 md:p-6 text-left cursor-pointer hover:bg-[#FDFBF7] transition-colors"
              >
                <h3
                  itemProp="name"
                  className="text-sm md:text-base font-semibold text-[#2A2A2A] pr-4"
                >
                  {faq.question}
                </h3>
                <div className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-lg md:text-xl text-[#D4AF37] transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              {/* Answer section with smooth transition */}
              <div
                itemScope={true}
                itemProp="acceptedAnswer"
                itemType="https://schema.org/Answer"
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-6 pb-4 md:pb-6">
                  <p
                    itemProp="text"
                    className="text-xs md:text-sm text-gray-600 leading-relaxed"
                  >
                    {faq.answer}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
